import { DateTime } from 'luxon';
import * as XLSX from 'xlsx';

import { toSafeExcelFileName } from '../common/excel/excelHelpers';

const parseNote = ({
  noteObject = {},
  authorKey = 'userId',
  userMap = {},
  currentUserId,
}) => {
  const {
    [authorKey]: authorId,
    timestamp,
    lastEditedUserId,
    lastEditedTimestamp,
  } = noteObject;
  const user = userMap[authorId] || {};
  const lastEditedUser = userMap[lastEditedUserId] || {};
  return {
    ...noteObject,
    user,
    authorName: user.name || '',
    date: timestamp ? DateTime.fromMillis(Number(timestamp)) : null,
    isCurrentUser: authorId === currentUserId,
    lastEditedDate: lastEditedTimestamp
      ? DateTime.fromMillis(Number(lastEditedTimestamp))
      : null,
    lastEditedByName: lastEditedUser.name || '',
  };
};

const exportNotes = ({
  notesList = [],
  exportTitle,
  authorKey = 'userId',
  userMap = {},
}) => {
  if (!exportTitle) return;
  const rows = [...notesList]
    .sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0))
    .map((noteObject) => {
      const { authorName, date, note } = parseNote({
        noteObject,
        authorKey,
        userMap,
      });
      return [
        authorName,
        date?.isValid ? date.toLocaleString(DateTime.DATETIME_MED) : '',
        note || '',
      ];
    });
  const sheet = XLSX.utils.aoa_to_sheet([
    ['Author', 'Date/Time', 'Note text'],
    ...rows,
  ]);
  sheet['!cols'] = [{ wch: 10 }, { wch: 20 }, { wch: 60 }];
  const workbook = XLSX.utils.book_new();
  const fileName = toSafeExcelFileName(exportTitle);
  XLSX.utils.book_append_sheet(workbook, sheet);
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export { exportNotes, parseNote };
